export async function loadHtmlPartialScripts(
	el: HTMLElement,
	fetchPriority: 'low' | 'high' = 'high',
	targetEl: HTMLElement | null = null
): Promise<void> {
	const newInlineScriptToExecute: HTMLScriptElement[] = []
	const newScriptsToAdd: string[] = []

	el.querySelectorAll('script').forEach(el => {
		if (el.src) {
			newScriptsToAdd.push(el.src)

			el.remove()
		} else if (el.innerText) {
			newInlineScriptToExecute.push(el)
		}
	})

	// Todo:  do we want to execute inline scripts ???
	const executeInlineScripts = (scriptsToExecute: HTMLScriptElement[]) => {
		scriptsToExecute.forEach(s => {
			try {
				eval(s.innerText)
			} catch (error) {
				window.console.error(`SCRIPT LOADING ERROR:  Failed to execute script: ${error}`)
			}
		})
	}
	if (executeInlineScripts.length) {
		executeInlineScripts(newInlineScriptToExecute)
	}

	// Scripts won't automatically execute when using innerHTML, need to grab them and add them
	// manually
	const loadScripts = async (scriptsToAdd: string[]) => {
		const load: (scriptUrl: string) => Promise<Event> = (scriptUrl: string) => {
			return new Promise((resolve, reject) => {
				const scriptEl: HTMLScriptElement = document.createElement('script')
				scriptEl.fetchPriority = fetchPriority
				scriptEl.onload = resolve
				scriptEl.onerror = (): void => {
					reject(new Error(`Error loading script: ${scriptUrl}`))
				}
				scriptEl.src = scriptUrl
				scriptEl.async = true
				if (targetEl) {
					targetEl.appendChild(scriptEl)
				} else {
					document.body.appendChild(scriptEl)
				}
			})
		}

		const promises: Promise<Event>[] = []
		scriptsToAdd.forEach(s => {
			promises.push(load(s))
		})
		await Promise.all(promises)
	}

	if (newScriptsToAdd.length) {
		await loadScripts(newScriptsToAdd)
	}
}
